'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import iconBack from './arrow-back-grey.png';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

var _validation = require('utils/validation');

var _lib = require('helpers/lib');

var _shops = require('redux/modules/shops');

var shopsActions = _interopRequireWildcard(_shops);

var _reactRouterRedux = require('react-router-redux');

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _FilterNewShop = require('./FilterNewShop');

var _FilterNewShop2 = _interopRequireDefault(_FilterNewShop);

var _reactPlacesAutocomplete = require('react-places-autocomplete');

var _reactPlacesAutocomplete2 = _interopRequireDefault(_reactPlacesAutocomplete);

var _lodash = require('lodash');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconLoading = '/actions/load.gif';
var NewShopMobie = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    errors: state.shops.errorsCreate,
    user: state.auth.user,
    districts: state.shops.districts,
    districtLoading: state.shops.districtLoading,
    districtParent: state.shops.districtParent,
    provinces: state.address.provinces,
    categories: state.setup.categories,
    created: state.shops.created,
    creating: state.shops.creating
  };
}, (0, _extends3.default)({}, shopsActions, { push: _reactRouterRedux.push })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(NewShopMobie, _Component);

  function NewShopMobie() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NewShopMobie);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NewShopMobie.__proto__ || (0, _getPrototypeOf2.default)(NewShopMobie)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      shopNew: {
        address: '',
        category: [],
        description: '',
        district: '',
        name: '',
        phone: '',
        location: {},
        priceRange: '',
        openTime: 540,
        closeTime: 1410,
        province: '',
        prominent: false,
        owner_id: _this.props.user._id,
        createdBy: _this.props.user && _this.props.user._id
      },
      times: (0, _lib.arrayTime)(),
      coverImage: [],
      images: [],
      validation: {},
      errors: {},
      subCatFilter: {},
      catsActive: [],
      subsActive: {},
      showCategory: false,
      showModalAlertSuccess: false,
      searchDistrictResult: '',
      viewPage: 1
    }, _this.rejectFiles = function () {
      _this.setState({
        errorMsg: 'Dung lượng ảnh quá lớn, mời bạn thử lại với file ảnh nhẹ hơn.'
      });
    }, _this.acceptFiles = function () {
      _this.setState({
        errorMsg: ''
      });
    }, _this.handleCloseModalAlertSuccess = function () {
      _this.props.initNew();
      _this.props.push('/');
    }, _this.handleSubmit = function (event) {
      event.preventDefault();
      var surveyValidation = (0, _validation.createValidator)({
        name: [_validation.required],
        phone: [_validation.required],
        cover: [_validation.required],
        address: [_validation.required]
      });
      var errors = surveyValidation((0, _extends3.default)({}, _this.state.shopNew, {
        cover: _this.state.coverImage.length > 0 ? _this.state.coverImage[0].preview : ''
      }));
      if ((0, _lodash.isEmpty)(errors)) {
        _this.setState({ validation: {} });
        var shopNew = _this.state.shopNew;
        shopNew.location = (0, _stringify2.default)(shopNew.location);
        var images = [].concat((0, _toConsumableArray3.default)(_this.state.coverImage), (0, _toConsumableArray3.default)(_this.state.images));
        // Nếu không có lỗi thì gửi lên, hình cũng là trường bắt buộc vì vậy phải validation cả hình ảnh nữa.
        _this.props.createShop(shopNew, images);
      } else {
        var viewPage = 2;
        if (errors.name || errors.phone) {
          viewPage = 1;
        }
        _this.setState({ validation: errors, viewPage: viewPage });
      }
    }, _this.handleChange = function (event) {
      var field = event.target.name;
      var value = event.target.value;
      if (event.target.type === 'checkbox') {
        value = event.target.checked;
      }
      var obj = _this.state.shopNew;
      obj[field] = value;
      _this.setState({ shopNew: obj });
      if (obj.province !== _this.props.districtParent && !_this.props.districtLoading) {
        _this.props.loadDistrict(obj.province);
      }
    }, _this.handleChangeAddress = function (address, location) {
      var field = 'address';
      var value = address;
      var obj = _this.state.shopNew;
      obj[field] = value;
      if (location) obj.location = location;
      _this.setState({ shopNew: obj });
      if (obj.province !== _this.props.districtParent && !_this.props.districtLoading) {
        _this.props.loadDistrict(obj.province);
      }
    }, _this.handleSelect = function (address) {
      (0, _reactPlacesAutocomplete.geocodeByAddress)(address).then(function (results) {
        var addressComponents = results[0].address_components;
        var provinceName = addressComponents[addressComponents.length - 2].short_name;
        var provinceCode = _this.props.provinces.find(function (prv) {
          return prv.name === provinceName;
        }).code;
        var obj = _this.state.shopNew;
        obj.province = provinceCode;
        _this.setState({
          shopNew: obj,
          searchDistrictResult: addressComponents[addressComponents.length - 3].short_name
        });
        (0, _reactPlacesAutocomplete.getLatLng)(results[0]).then(function (latLng) {
          _this.handleChangeAddress(address, latLng);
        });
      }).catch(function (error) {
        console.error('Error', error);
      });
    }, _this.handleChangeCategory = function (event) {
      var field = event.target.name;
      var value = event.target.checked;
      var code = event.target.id;
      var obj = _this.state.shopNew;
      if (value) {
        obj[field].push(code);
      } else {
        obj[field] = (0, _lodash.without)(obj[field], code.toString());
      }
      _this.setState({ shopNew: obj });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NewShopMobie, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var categories = this.props.categories;

      if (categories && categories.length > 0) {
        var subsActive = {};
        categories.map(function (cat) {
          subsActive[cat.code] = [];
        });
        this.setState({ subsActive: subsActive });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.errors !== this.props.errors) {
        this.setState({ errors: nextProps.errors });
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(acceptedFiles) {
      this.setState({ images: acceptedFiles });
    }
  }, {
    key: 'onDropCover',
    value: function onDropCover(coverFile) {
      this.setState({ coverImage: coverFile });
    }
  }, {
    key: 'onBack',
    value: function onBack() {
      var viewPage = this.state.viewPage;

      if (viewPage === 2) {
        this.setState({ viewPage: 1 });
      } else {
        _reactRouter.browserHistory.goBack();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.districts !== nextProps.districts) {
        var district = nextProps.districts.find(function (dist) {
          return dist.name === _this2.state.searchDistrictResult;
        });
        if (district) {
          var obj = this.state.shopNew;
          obj.district = district.code;
          this.setState({
            shopNew: obj
          });
        }
      }
    }
  }, {
    key: 'toggleFilter',
    value: function toggleFilter() {
      this.setState({ showCategory: !this.state.showCategory });
    }
  }, {
    key: 'handleFilterSubmit',
    value: function handleFilterSubmit(filter) {
      var catsActive = filter.catsActive,
          subsActive = filter.subsActive,
          allCats = filter.allCats;

      var obj = this.state.shopNew;
      obj.category = allCats;
      this.setState({ catsActive: catsActive, subsActive: subsActive, shopNew: obj });
      this.toggleFilter();
    }
  }, {
    key: 'iconCat',
    value: function iconCat(code) {
      var styles = require('./NewShopMobile.scss');
      switch (code) {
        case '01':
          return _react2.default.createElement('img', { className: styles.spa, src: _Images2.default.cats.spa });
        case '02':
          return _react2.default.createElement('img', { className: styles.hair, src: _Images2.default.cats.hair });
        case '03':
          return _react2.default.createElement('img', { className: styles.cosmetic, src: _Images2.default.cats.cosmetic });
        case '04':
          return _react2.default.createElement('img', { className: styles.clinic, src: _Images2.default.cats.clinic });
        case '05':
          return _react2.default.createElement('img', { className: styles.fitness, src: _Images2.default.cats.fitness });
        case '06':
          return _react2.default.createElement('img', { className: styles.tatoo, src: _Images2.default.cats.tatoo });
        case '07':
          return _react2.default.createElement('img', { className: styles.homeService, src: _Images2.default.cats.homeService });
        default:
          break;
      }
    }
  }, {
    key: 'renderCatsActive',
    value: function renderCatsActive() {
      var _this3 = this;

      var styles = require('./NewShopMobile.scss');
      var categories = this.props.categories;
      var catsActive = this.state.catsActive;

      var lists = [];
      categories.map(function (cat) {
        if (catsActive.indexOf(cat.code) !== -1) {
          lists.push({ code: cat.code, label: cat.label });
        }
      });
      return _react2.default.createElement(
        'div',
        { className: styles.catsActive },
        lists && lists.length > 0 && lists.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { className: styles.label, key: 'lType_' + index },
            _this3.iconCat(item.code),
            _react2.default.createElement(
              'span',
              null,
              item.label
            )
          );
        })
      );
    }
  }, {
    key: 'nextPage',
    value: function nextPage() {
      var surveyValidation = (0, _validation.createValidator)({
        name: [_validation.required],
        phone: [_validation.required]
      });
      var errors = surveyValidation((0, _extends3.default)({}, this.state.shopNew));
      if (errors.name && errors.phone) {
        this.setState({ validation: errors });
      } else {
        this.setState({ viewPage: 2 });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var styles = require('./NewShopMobile.scss');
      var _props = this.props,
          categories = _props.categories,
          provinces = _props.provinces,
          districts = _props.districts,
          creating = _props.creating,
          created = _props.created;
      var _state = this.state,
          coverImage = _state.coverImage,
          images = _state.images,
          errorMsg = _state.errorMsg,
          shopNew = _state.shopNew,
          validation = _state.validation,
          errors = _state.errors,
          showCategory = _state.showCategory,
          catsActive = _state.catsActive,
          subsActive = _state.subsActive,
          viewPage = _state.viewPage,
          times = _state.times;

      var types = [];
      // const google = global.google;
      var searchOptions = {
        types: ['address']
      };
      if (categories && categories.length > 0) {
        for (var index = 0; index < categories.length; index++) {
          var subList = [];
          var code = categories[index].code;
          if (categories[index].childrens && categories[index].childrens.length > 0) {
            var childrens = categories[index].childrens;
            for (var jndex = 0; jndex < childrens.length; jndex++) {
              var subCode = childrens[jndex].code;
              subList.push(_react2.default.createElement(
                'li',
                { key: String(index + '-' + jndex) },
                _react2.default.createElement('input', {
                  type: 'checkbox',
                  id: subCode,
                  name: 'category',
                  onChange: this.handleChangeCategory
                }),
                _react2.default.createElement(
                  'label',
                  { htmlFor: subCode },
                  childrens[jndex].label
                )
              ));
            }
            types.push(_react2.default.createElement(
              'li',
              { key: String(index) },
              _react2.default.createElement('input', {
                type: 'checkbox',
                id: code,
                name: 'category',
                onChange: this.handleChangeCategory,
                className: styles.mainCat
              }),
              _react2.default.createElement(
                'label',
                { className: styles.labelMainCat, htmlFor: code },
                categories[index].label
              ),
              _react2.default.createElement(
                'ul',
                { className: styles.subList },
                subList
              )
            ));
          } else {
            types.push(_react2.default.createElement(
              'li',
              { key: String(index) },
              _react2.default.createElement('input', {
                type: 'checkbox',
                id: code,
                name: 'category',
                onChange: this.handleChangeCategory,
                className: styles.mainCat
              }),
              _react2.default.createElement(
                'label',
                { className: styles.labelMainCat, htmlFor: code },
                categories[index].label
              )
            ));
          }
        }
      }
      return _react2.default.createElement(
        'div',
        { className: styles.newShopMobile },
        creating && _react2.default.createElement(
          'div',
          { className: styles.loadingFade },
          _react2.default.createElement(
            'div',
            { className: styles.loading },
            _react2.default.createElement('img', { src: iconLoading })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.newshopHeader },
          _react2.default.createElement(
            'div',
            { className: styles.arrowBack, onClick: this.onBack.bind(this) },
            _react2.default.createElement('img', { src: 'icon/ic_back/ic_back.png' }),
            'Back'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.formTitle },
          _react2.default.createElement(
            'span',
            { className: styles.title },
            'T\u1EA1o c\u1EEDa h\xE0ng m\u1EDBi'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.breadcrum },
            _react2.default.createElement(
              'span',
              { className: styles.active },
              'Th\xF4ng tin',
              ' ',
              _react2.default.createElement(_reactBootstrap.Glyphicon, {
                className: styles.active + ' ' + styles.icon,
                glyph: 'menu-right'
              })
            ),
            _react2.default.createElement(
              'span',
              { className: '' + (viewPage === 2 ? styles.active : '') },
              'T\u1EA1o c\u1EEDa h\xE0ng'
            )
          )
        ),
        _react2.default.createElement(
          'form',
          { className: styles.loginContent, onSubmit: this.handleSubmit },
          _react2.default.createElement(
            'div',
            {
              className: styles.formLogin + ' formLogin ' + (viewPage !== 1 ? styles.phide : '')
            },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                null,
                'T\xEAn c\u1EEDa h\xE0ng ',
                _react2.default.createElement(
                  'div',
                  { className: styles.required },
                  '*'
                )
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formGroup },
                _react2.default.createElement(_reactBootstrap.FormControl, {
                  className: styles.inputLogin,
                  name: 'name',
                  type: 'text',
                  placeholder: 'T\xEAn c\u1EEDa h\xE0ng',
                  onChange: this.handleChange,
                  value: shopNew.name
                }),
                !(0, _lodash.isEmpty)(validation) && validation.name && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  validation.name
                ),
                !(0, _lodash.isEmpty)(errors) && errors.name && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  errors.name
                )
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                null,
                'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i ',
                _react2.default.createElement(
                  'div',
                  { className: styles.required },
                  '*'
                )
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formGroup },
                _react2.default.createElement(_reactBootstrap.FormControl, {
                  className: styles.inputLogin,
                  name: 'phone',
                  type: 'text',
                  placeholder: 'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i',
                  onChange: this.handleChange,
                  value: shopNew.phone
                }),
                !(0, _lodash.isEmpty)(validation) && validation.phone && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  validation.phone
                ),
                !(0, _lodash.isEmpty)(errors) && errors.phone && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  errors.phone
                )
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                null,
                'Lo\u1EA1i h\xECnh'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.pcategory, onClick: this.toggleFilter.bind(this) },
                _react2.default.createElement(
                  'div',
                  { className: styles.text },
                  'Ch\u1ECDn lo\u1EA1i c\u1EEDa h\xE0ng'
                ),
                _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'menu-right' })
              ),
              this.renderCatsActive(),
              !(0, _lodash.isEmpty)(validation) && validation.category && _react2.default.createElement(
                'div',
                { className: styles.help },
                validation.category
              ),
              !(0, _lodash.isEmpty)(errors) && errors.category && _react2.default.createElement(
                'div',
                { className: styles.help },
                errors.category
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: styles.formLogin + ' formLogin ' + (viewPage !== 2 ? styles.phide : '')
            },
            _react2.default.createElement(
              'div',
              {
                className: styles.coverBox + ' ' + (!(0, _lodash.isEmpty)(validation) && validation.cover ? styles.coverError : '')
              },
              _react2.default.createElement(
                _reactDropzone2.default,
                {
                  className: 'drop-zone',
                  multiple: false,
                  onDrop: this.onDropCover.bind(this),
                  accept: 'image/*',
                  maxSize: 10000000,
                  onDropRejected: function onDropRejected() {
                    return _this4.rejectFiles();
                  },
                  onDropAccepted: function onDropAccepted() {
                    return _this4.acceptFiles();
                  }
                },
                _react2.default.createElement(
                  'div',
                  { className: styles.btnCover },
                  _react2.default.createElement('span', { className: styles.coverIcon }),
                  _react2.default.createElement(
                    'label',
                    null,
                    '\u0110\u1ED5i \u1EA3nh b\xECa ',
                    _react2.default.createElement(
                      'div',
                      { className: styles.required },
                      '*'
                    )
                  )
                )
              ),
              coverImage.length > 0 ? _react2.default.createElement('img', { src: coverImage[0].preview, alt: '' }) : _react2.default.createElement('img', { src: '/cover_default.png', alt: '' })
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'col-xs-6',
                style: { paddingLeft: '0', paddingRight: '15px' }
              },
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                null,
                'Gi\u1EDD l\xE0m vi\u1EC7c'
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formTime + ' ' + styles.formGroup },
                _react2.default.createElement('div', { className: styles.iconTime }),
                _react2.default.createElement(
                  _reactBootstrap.FormControl,
                  {
                    componentClass: 'select',
                    className: styles.inputLogin,
                    name: 'openTime',
                    type: 'number',
                    placeholder: '9h00',
                    onChange: this.handleChange,
                    value: shopNew.openTime
                  },
                  times.map(function (v, i) {
                    return _react2.default.createElement(
                      'option',
                      { value: v.value, key: 'openTime_' + i },
                      v.label
                    );
                  })
                ),
                !(0, _lodash.isEmpty)(validation) && validation.openTime && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  validation.openTime
                ),
                !(0, _lodash.isEmpty)(errors) && errors.openTime && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  errors.openTime
                )
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'col-xs-6',
                style: { paddingLeft: '15px', paddingRight: '0' }
              },
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                null,
                'Gi\u1EDD ngh\u1EC9 vi\u1EC7c'
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formTime + ' ' + styles.formGroup },
                _react2.default.createElement('div', { className: styles.iconTime }),
                _react2.default.createElement(
                  _reactBootstrap.FormControl,
                  {
                    componentClass: 'select',
                    className: styles.inputLogin,
                    name: 'closeTime',
                    type: 'number',
                    placeholder: '21h00',
                    onChange: this.handleChange,
                    value: shopNew.closeTime
                  },
                  times.map(function (v, i) {
                    return _react2.default.createElement(
                      'option',
                      { value: v.value, key: 'openTime_' + i },
                      v.label
                    );
                  })
                ),
                !(0, _lodash.isEmpty)(validation) && validation.closeTime && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  validation.closeTime
                ),
                !(0, _lodash.isEmpty)(errors) && errors.closeTime && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  errors.closeTime
                )
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'col-xs-12',
                style: { paddingLeft: '0', paddingRight: '0' }
              },
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                null,
                'Gi\xE1 c\u1EA3'
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formGroup },
                _react2.default.createElement(_reactBootstrap.FormControl, {
                  className: styles.inputLogin,
                  name: 'priceRange',
                  type: 'text',
                  placeholder: '150.000\u0111 - 2.000.000\u0111',
                  onChange: this.handleChange,
                  value: shopNew.priceRange
                }),
                !(0, _lodash.isEmpty)(validation) && validation.priceRange && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  validation.priceRange
                ),
                !(0, _lodash.isEmpty)(errors) && errors.priceRange && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  errors.priceRange
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12', style: { padding: '0' } },
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                null,
                '\u0110\u1ECBa ch\u1EC9 ',
                _react2.default.createElement(
                  'div',
                  { className: styles.required },
                  '*'
                )
              ),
              _react2.default.createElement(
                _reactPlacesAutocomplete2.default,
                {
                  value: shopNew.address,
                  onChange: this.handleChangeAddress,
                  onSelect: this.handleSelect,
                  searchOptions: searchOptions
                },
                function (_ref2) {
                  var getInputProps = _ref2.getInputProps,
                      suggestions = _ref2.suggestions,
                      getSuggestionItemProps = _ref2.getSuggestionItemProps,
                      loading = _ref2.loading;
                  return _react2.default.createElement(
                    'div',
                    { className: styles.addressSearchContainer },
                    _react2.default.createElement('input', getInputProps({
                      placeholder: 'Địa chỉ',
                      className: 'location-search-input'
                    })),
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'autocomplete-dropdown-container ' + (suggestions.length > 0 ? styles.addressAutoComplete : '')
                      },
                      loading && _react2.default.createElement(
                        'div',
                        null,
                        'Loading...'
                      ),
                      suggestions.map(function (suggestion) {
                        var className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                        // inline style for demonstration purpose
                        var style = suggestion.active ? { backgroundColor: '#fafafa', cursor: 'pointer' } : { backgroundColor: '#ffffff', cursor: 'pointer' };
                        return _react2.default.createElement(
                          'div',
                          getSuggestionItemProps(suggestion, {
                            className: className,
                            style: style
                          }),
                          _react2.default.createElement(
                            'span',
                            null,
                            suggestion.description
                          )
                        );
                      })
                    )
                  );
                }
              ),
              !(0, _lodash.isEmpty)(validation) && validation.address && _react2.default.createElement(
                'div',
                { className: styles.help },
                validation.address
              ),
              !(0, _lodash.isEmpty)(errors) && errors.address && _react2.default.createElement(
                'div',
                { className: styles.help },
                errors.address
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'col-xs-6',
                style: { paddingLeft: '0', paddingRight: '15px' }
              },
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                null,
                'Khu v\u1EF1c'
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formGroup },
                _react2.default.createElement(
                  _reactBootstrap.FormControl,
                  {
                    componentClass: 'select',
                    name: 'district'
                    // onChange={this.handleChange}
                    , value: shopNew.district
                    // disabled={!shopNew.province ? 'disabled' : ''}
                    // disabled
                  },
                  _react2.default.createElement(
                    'option',
                    { value: '' },
                    'Qu\u1EADn huy\u1EC7n'
                  ),
                  districts && districts.map(function (district, index) {
                    return _react2.default.createElement(
                      'option',
                      { value: district.code, key: index },
                      district.name
                    );
                  })
                ),
                !(0, _lodash.isEmpty)(validation) && validation.district && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  validation.district
                ),
                !(0, _lodash.isEmpty)(errors) && errors.district && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  errors.district
                )
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'col-xs-6',
                style: { paddingLeft: '15px', paddingRight: '0' }
              },
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                null,
                'T\u1EC9nh/Th\xE0nh Ph\u1ED1'
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formGroup },
                _react2.default.createElement(
                  _reactBootstrap.FormControl,
                  {
                    componentClass: 'select',
                    name: 'province',
                    onChange: this.handleChange,
                    value: shopNew.province
                    // disabled
                  },
                  _react2.default.createElement(
                    'option',
                    { value: '' },
                    'T\u1EC9nh Th\xE0nh'
                  ),
                  provinces && provinces.map(function (province, index) {
                    return _react2.default.createElement(
                      'option',
                      { value: province.code, key: index },
                      province.name
                    );
                  })
                ),
                !(0, _lodash.isEmpty)(validation) && validation.province && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  validation.province
                ),
                !(0, _lodash.isEmpty)(errors) && errors.province && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  errors.province
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12', style: { padding: '0' } },
              _react2.default.createElement(
                _reactBootstrap.ControlLabel,
                null,
                'M\xF4 t\u1EA3'
              ),
              _react2.default.createElement(
                _reactBootstrap.FormGroup,
                { className: styles.formGroup },
                _react2.default.createElement(_reactBootstrap.FormControl, (0, _defineProperty3.default)({
                  className: styles.inputLogin,
                  componentClass: 'textarea',
                  name: 'description',
                  placeholder: '150.000\u0111 - 2.000.000\u0111',
                  onChange: this.handleChange,
                  value: shopNew.description
                }, 'placeholder', 'Nh\u1EADp v\xE0o m\xF4 t\u1EA3 chi ti\u1EBFt v\u1EC1 c\u1EEDa h\xE0ng c\u1EE7a b\u1EA1n...')),
                !(0, _lodash.isEmpty)(validation) && validation.description && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  validation.description
                ),
                !(0, _lodash.isEmpty)(errors) && errors.description && _react2.default.createElement(
                  'div',
                  { className: styles.help },
                  errors.description
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.videoImage },
              _react2.default.createElement(
                'div',
                { className: styles.label },
                'H\xECnh \u1EA3nh'
              ),
              _react2.default.createElement(
                _reactDropzone2.default,
                {
                  className: 'dropzone',
                  onDrop: this.onDrop.bind(this),
                  multiple: true,
                  accept: 'image/*',
                  maxSize: 10000000,
                  onDropRejected: function onDropRejected() {
                    return _this4.rejectFiles();
                  },
                  onDropAccepted: function onDropAccepted() {
                    return _this4.acceptFiles();
                  },
                  style: { float: 'left', marginRight: '10px' }
                },
                _react2.default.createElement('div', { className: styles.addImageVideo })
              ),
              images.length > 0 && _react2.default.createElement(
                'div',
                { style: { float: 'left' } },
                images.map(function (image, index) {
                  // const imgBackGr = {backgroundImage: `url:(${image.preview})`};
                  return image.type.split('/')[0] === 'video' ? _react2.default.createElement(
                    'div',
                    { key: image.lastModified },
                    _react2.default.createElement('video', {
                      src: image.preview,
                      key: image.lastModified + '_' + index,
                      width: '100%',
                      height: '250px',
                      controls: true
                    })
                  ) : _react2.default.createElement('img', {
                    src: image.preview,
                    key: image.lastModified + '_' + index,
                    className: styles.thumbImage
                  });
                })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.errorMessage },
                errorMsg
              )
            )
          ),
          viewPage === 1 && _react2.default.createElement(
            'div',
            { className: styles.btnNext, onClick: this.nextPage.bind(this) },
            'Ti\u1EBFp Theo'
          ),
          viewPage === 2 && _react2.default.createElement(
            'button',
            { type: 'submit', className: styles.btnLogin },
            'T\u1EA1o c\u1EEDa h\xE0ng'
          )
        ),
        _react2.default.createElement(_FilterNewShop2.default, {
          showFilter: showCategory,
          catsActive: catsActive,
          subsActive: subsActive,
          categories: categories,
          toggleFilter: this.toggleFilter.bind(this),
          handleSubmit: this.handleFilterSubmit.bind(this)
        }),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          null,
          _react2.default.createElement(
            'div',
            {
              className: 'col-xs-6',
              style: { paddingLeft: '0', paddingRight: '5px' }
            },
            _react2.default.createElement(
              _reactBootstrap.ControlLabel,
              null,
              'Gi\u1EDD l\xE0m vi\u1EC7c'
            ),
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              { className: styles.formGroup },
              _react2.default.createElement(_reactBootstrap.FormControl, {
                className: styles.inputLogin,
                name: 'openTime',
                type: 'text',
                placeholder: '9h00',
                onChange: this.handleChange,
                value: shopNew.openTime
              }),
              !(0, _lodash.isEmpty)(validation) && validation.openTime && _react2.default.createElement(
                'div',
                { className: styles.help },
                validation.openTime
              ),
              !(0, _lodash.isEmpty)(errors) && errors.openTime && _react2.default.createElement(
                'div',
                { className: styles.help },
                errors.openTime
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'col-xs-6',
              style: { paddingLeft: '0', paddingRight: '5px' }
            },
            _react2.default.createElement(
              _reactBootstrap.ControlLabel,
              null,
              'Gi\u1EDD ngh\u1EC9 vi\u1EC7c'
            ),
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              { className: styles.formGroup },
              _react2.default.createElement(_reactBootstrap.FormControl, {
                className: styles.inputLogin,
                name: 'closeTime',
                type: 'text',
                placeholder: '21h00',
                onChange: this.handleChange,
                value: shopNew.closeTime
              }),
              !(0, _lodash.isEmpty)(validation) && validation.closeTime && _react2.default.createElement(
                'div',
                { className: styles.help },
                validation.closeTime
              ),
              !(0, _lodash.isEmpty)(errors) && errors.closeTime && _react2.default.createElement(
                'div',
                { className: styles.help },
                errors.closeTime
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'col-xs-6',
              style: { paddingLeft: '5px', paddingRight: '0' }
            },
            _react2.default.createElement(
              _reactBootstrap.ControlLabel,
              null,
              'Gi\xE1 c\u1EA3'
            ),
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              { className: styles.formGroup },
              _react2.default.createElement(_reactBootstrap.FormControl, {
                className: styles.inputLogin,
                name: 'priceRange',
                type: 'text',
                placeholder: '150.000\u0111 - 2.000.000\u0111',
                onChange: this.handleChange,
                value: shopNew.priceRange
              }),
              !(0, _lodash.isEmpty)(validation) && validation.priceRange && _react2.default.createElement(
                'div',
                { className: styles.help },
                validation.priceRange
              ),
              !(0, _lodash.isEmpty)(errors) && errors.priceRange && _react2.default.createElement(
                'div',
                { className: styles.help },
                errors.priceRange
              )
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactBootstrap.ControlLabel,
              null,
              '\u0110\u1ECBa ch\u1EC9'
            ),
            _react2.default.createElement(
              _reactPlacesAutocomplete2.default,
              {
                value: shopNew.address,
                onChange: this.handleChangeAddress,
                onSelect: this.handleSelect,
                searchOptions: searchOptions
              },
              function (_ref3) {
                var getInputProps = _ref3.getInputProps,
                    suggestions = _ref3.suggestions,
                    getSuggestionItemProps = _ref3.getSuggestionItemProps,
                    loading = _ref3.loading;
                return _react2.default.createElement(
                  'div',
                  { className: styles.addressSearchContainer },
                  _react2.default.createElement('input', getInputProps({
                    placeholder: 'Địa chỉ',
                    className: 'location-search-input'
                  })),
                  _react2.default.createElement(
                    'div',
                    { className: 'autocomplete-dropdown-container' },
                    loading && _react2.default.createElement(
                      'div',
                      null,
                      'Loading...'
                    ),
                    suggestions.map(function (suggestion) {
                      var className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                      // inline style for demonstration purpose
                      var style = suggestion.active ? { backgroundColor: '#fafafa', cursor: 'pointer' } : { backgroundColor: '#ffffff', cursor: 'pointer' };
                      return _react2.default.createElement(
                        'div',
                        getSuggestionItemProps(suggestion, {
                          className: className,
                          style: style
                        }),
                        _react2.default.createElement(
                          'span',
                          null,
                          suggestion.description
                        )
                      );
                    })
                  )
                );
              }
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'col-xs-6',
              style: { paddingLeft: '10px', paddingRight: '0' }
            },
            _react2.default.createElement(
              _reactBootstrap.ControlLabel,
              null,
              'T\u1EC9nh th\xE0nh'
            ),
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              { className: styles.formGroup },
              _react2.default.createElement(
                _reactBootstrap.FormControl,
                {
                  componentClass: 'select',
                  name: 'province',
                  onChange: this.handleChange,
                  value: shopNew.province,
                  disabled: true
                },
                _react2.default.createElement(
                  'option',
                  { value: '' },
                  'T\u1EC9nh Th\xE0nh'
                ),
                provinces && provinces.map(function (province, index) {
                  return _react2.default.createElement(
                    'option',
                    { value: province.code, key: index },
                    province.name
                  );
                })
              ),
              !(0, _lodash.isEmpty)(validation) && validation.province && _react2.default.createElement(
                'div',
                { className: styles.help },
                validation.province
              ),
              !(0, _lodash.isEmpty)(errors) && errors.province && _react2.default.createElement(
                'div',
                { className: styles.help },
                errors.province
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'col-xs-6',
              style: { paddingLeft: '0', paddingRight: '10px' }
            },
            _react2.default.createElement(
              _reactBootstrap.ControlLabel,
              null,
              'Khu v\u1EF1c'
            ),
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              { className: styles.formGroup },
              _react2.default.createElement(
                _reactBootstrap.FormControl,
                {
                  componentClass: 'select',
                  name: 'district'
                  // onChange={this.handleChange}
                  , value: shopNew.district
                  // disabled={!shopNew.province ? 'disabled' : ''}
                  , disabled: true
                },
                _react2.default.createElement(
                  'option',
                  { value: '' },
                  'Qu\u1EADn huy\u1EC7n'
                ),
                districts && districts.map(function (district, index) {
                  return _react2.default.createElement(
                    'option',
                    { value: district.code, key: index },
                    district.name
                  );
                })
              ),
              !(0, _lodash.isEmpty)(validation) && validation.district && _react2.default.createElement(
                'div',
                { className: styles.help },
                validation.district
              ),
              !(0, _lodash.isEmpty)(errors) && errors.district && _react2.default.createElement(
                'div',
                { className: styles.help },
                errors.district
              )
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactBootstrap.ControlLabel,
              null,
              'M\xF4 t\u1EA3'
            ),
            _react2.default.createElement(
              _reactBootstrap.FormGroup,
              { className: styles.formGroup },
              _react2.default.createElement(_reactBootstrap.FormControl, (0, _defineProperty3.default)({
                className: styles.inputLogin,
                componentClass: 'textarea',
                name: 'description',
                placeholder: '150.000\u0111 - 2.000.000\u0111',
                onChange: this.handleChange,
                value: shopNew.description
              }, 'placeholder', 'M\xF4 t\u1EA3')),
              !(0, _lodash.isEmpty)(validation) && validation.description && _react2.default.createElement(
                'div',
                { className: styles.help },
                validation.description
              ),
              !(0, _lodash.isEmpty)(errors) && errors.description && _react2.default.createElement(
                'div',
                { className: styles.help },
                errors.description
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.videoImage },
            _react2.default.createElement(
              'div',
              { className: styles.label },
              'H\xECnh \u1EA3nh'
            ),
            _react2.default.createElement(
              _reactDropzone2.default,
              {
                className: 'dropzone',
                onDrop: this.onDrop.bind(this),
                multiple: true,
                accept: 'image/*',
                maxSize: 10000000,
                onDropRejected: function onDropRejected() {
                  return _this4.rejectFiles();
                },
                onDropAccepted: function onDropAccepted() {
                  return _this4.acceptFiles();
                },
                style: { float: 'left', marginRight: '10px' }
              },
              _react2.default.createElement('div', { className: styles.addImageVideo })
            ),
            images.length > 0 && _react2.default.createElement(
              'div',
              { style: { float: 'left' } },
              images.map(function (image, index) {
                // const imgBackGr = {backgroundImage: `url:(${image.preview})`};
                return image.type.split('/')[0] === 'video' ? _react2.default.createElement(
                  'div',
                  { key: image.lastModified },
                  _react2.default.createElement('video', {
                    src: image.preview,
                    key: image.lastModified + '_' + index,
                    width: '100%',
                    height: '250px',
                    controls: true
                  })
                ) : _react2.default.createElement('img', {
                  src: image.preview,
                  key: image.lastModified + '_' + index,
                  className: styles.thumbImage
                });
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.errorMessage },
              errorMsg
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: created,
            hide: this.handleCloseModalAlertSuccess,
            className: 'modal-alert-mobile'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: this.handleCloseModalAlertSuccess
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalAlert },
            _react2.default.createElement(
              'div',
              { className: styles.headerAlert },
              'C\u1EA3m \u01A1n b\u1EA1n \u0111\xE3 h\u1ED7 tr\u1EE3!'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.contentAlert },
              '\u0110\u1ECBa \u0111i\u1EC3m b\u1EA1n v\u1EEBa th\xEAm \u0111ang \u0111\u01B0\u1EE3c duy\u1EC7t, ch\xFAng t\xF4i s\u1EBD li\xEAn l\u1EA1c l\u1EA1i v\u1EDBi b\u1EA1n \u0111\u1EC3 x\xE1c nh\u1EADn th\xF4ng tin s\u1EDBm.'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.actionButtons },
              _react2.default.createElement(
                'div',
                {
                  className: styles.btnLogin,
                  onClick: this.handleCloseModalAlertSuccess
                },
                '\u0110\xF3ng'
              )
            )
          )
        )
      );
    }
  }]);
  return NewShopMobie;
}(_react.Component), _class2.propTypes = {
  errors: _react.PropTypes.object,
  createShop: _react.PropTypes.func.isRequired,
  loadDistrict: _react.PropTypes.func.isRequired,
  push: _react.PropTypes.func.isRequired,
  initNew: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object,
  districts: _react.PropTypes.array,
  provinces: _react.PropTypes.array,
  categories: _react.PropTypes.array,
  districtLoading: _react.PropTypes.bool,
  districtParent: _react.PropTypes.string,
  created: _react.PropTypes.bool,
  creating: _react.PropTypes.bool
}, _temp2)) || _class);
exports.default = NewShopMobie;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/NewShopMobile/NewShopMobile.js
// module id = 1615
// module chunks = 0